import { preventGuides } from '@/mocks/homeData';

export default function PreventGridSection() {
  const feature = preventGuides.find((item) => item.size === 'large');
  const smalls = preventGuides.filter((item) => item.size === 'small');

  return (
    <section id="prevent" className="scroll-mt-24 w-full bg-background-100 border-y border-background-200 py-14 md:py-20">
      <div className="w-full px-4 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.16em] text-secondary-700 uppercase">
              <i className="ri-bookmark-2-line" aria-hidden="true" />
              Anti-Lost Handbook
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              防走丢与防屏蔽手册
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              下面这些是我们反复被问到的问题，整理成短篇卡片。挑你最关心的看，几分钟就能把访问习惯理顺。
            </p>
          </div>
          <a
            href="#faq"
            className="self-start lg:self-auto inline-flex items-center gap-2 px-5 py-3 rounded-md bg-secondary-500 text-background-50 text-sm font-label hover:bg-secondary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            直接看常见问题
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        {/* 大小卡混排网格 */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 md:gap-5">
          {feature && (
            <article className="lg:col-span-5 lg:row-span-2 md:col-span-2 flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 animate-fade-up">
              <div className="w-full h-56 md:h-72 bg-background-200">
                <img
                  src={feature.image}
                  alt={feature.title}
                  title={`黑料地址防走丢 ${feature.title}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex flex-col flex-1 p-5 md:p-6">
                <span className="self-start px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-[11px] font-label whitespace-nowrap">
                  {feature.tag}
                </span>
                <h3 className="mt-4 font-heading text-xl md:text-2xl font-bold leading-snug text-foreground-950">
                  {feature.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">{feature.excerpt}</p>
                <div className="mt-5 flex items-center justify-between pt-4 border-t border-background-200">
                  <span className="text-xs font-label text-foreground-500">{feature.meta}</span>
                  <span className="inline-flex items-center gap-1 text-sm font-label text-primary-700">
                    阅读全文
                    <i className="ri-arrow-right-up-line" aria-hidden="true" />
                  </span>
                </div>
              </div>
            </article>
          )}

          {smalls.map((item, index) => (
            <article
              key={item.id}
              className="lg:col-span-4 md:col-span-1 flex flex-col rounded-lg bg-background-50 border border-background-200 p-5 animate-fade-up transition-colors duration-300 hover:border-accent-300"
              style={{ animationDelay: `${(index + 1) * 90}ms` }}
            >
              <span className="self-start px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-[11px] font-label whitespace-nowrap">
                {item.tag}
              </span>
              <h3 className="mt-3.5 font-heading text-base md:text-lg font-bold leading-snug text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2.5 text-[13px] leading-relaxed text-foreground-700 flex-1">{item.excerpt}</p>
              <div className="mt-4 flex items-center justify-between text-xs font-label">
                <span className="text-foreground-500">{item.meta}</span>
                <i className="ri-arrow-right-line text-foreground-400" aria-hidden="true" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}